import { render, staticRenderFns } from "./FulFillOrderControl.vue?vue&type=template&id=b04082c0&scoped=true"
import script from "./FulFillOrderControl.vue?vue&type=script&lang=js"
export * from "./FulFillOrderControl.vue?vue&type=script&lang=js"
import "./FulFillOrderControl.vue?vue&type=style&index=0&id=b04082c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04082c0",
  null
  
)

export default component.exports